import { Pipe, PipeTransform } from '@angular/core';
import { Session } from '../models/session';

@Pipe({
  name: 'sessionListFilter'
})
export class SessionListFilter implements PipeTransform {

  transform(sessionList: Session[], filterText: string) {
    if (!sessionList) return sessionList;
    if (sessionList.length === 0 || filterText === "") {
      return sessionList;
    } else {
      return sessionList.filter((session) => {
        return session.name.toLowerCase().includes(filterText.toLowerCase()) || session.ip.toLowerCase().includes(filterText.toLowerCase());
      })
    }
  }

}
